import { T } from "@repo/transifex";
import { useUpdateTill } from "~/api/tills/hooks/use-update-till";
import { Button, SelectCreatable } from "~/components";
import { useAvailableLanguages } from "~/utils/transifex";
import { DisplayErrorMessage } from "~/components/display-error-message";

import { ConfigItem } from "./config-item";

export const ConfigItemLanguage = () => {
  const {
    data: languages,
    status: languagesStatus,
    error,
    refetch
  } = useAvailableLanguages();
  const { mutate: updateTill, status } = useUpdateTill();

  if (languagesStatus !== "success") {
    return (
      <ConfigItem
        title={<T _str="Language selector" />}
        description={
          languagesStatus === "pending" ? (
            <T _str="Languages are being loaded..." />
          ) : (
            <DisplayErrorMessage error={error} />
          )
        }
        allowedTillTypes={[
          "attended",
          "self-service",
          "collect",
          "kiosk",
          "simple-checkout",
          "ticket-validation"
        ]}
      >
        {() =>
          languagesStatus === "pending" ? null : (
            <Button onClick={() => refetch()} variant="danger">
              <T _str="Retry" />
            </Button>
          )
        }
      </ConfigItem>
    );
  }

  return (
    <ConfigItem
      title={<T _str="Language selector" />}
      description={
        status === "pending" ? (
          <T _str="Language is being updated..." />
        ) : (
          <T _str="You can change the language of the system here" />
        )
      }
      allowedTillTypes={[
        "attended",
        "self-service",
        "collect",
        "kiosk",
        "simple-checkout",
        "ticket-validation"
      ]}
    >
      {(till) => (
        <SelectCreatable
          className="!text-base"
          onChange={(selected) => {
            if (selected) {
              updateTill({ language: selected.value });
            }
          }}
          options={languages.map((language) => ({
            value: language.code,
            label: language.name
          }))}
          placeholder={<T _str="Choose a language" />}
          value={
            languages.find((lang) => lang.code === till.language)
              ? {
                  value: till.language,
                  label: languages.find((lang) => lang.code === till.language)
                    ?.name
                }
              : null
          }
        />
      )}
    </ConfigItem>
  );
};
